import React, { useState, useRef } from "react";
import Popup from "reactjs-popup";
import SignaturePad from "react-signature-canvas";
import "./css/sigCanvas.css";
import "./css/popup.css";
import { Box, Button, Grid, Typography } from "@mui/material";
import SafeImage, { SIGNATURE_PLACEHOLDER } from "./SafeImage";

export const Signature = ({ ...props }) => {
    const pencolor = props?.pencolor || "black";
    const minWidth = props?.minWidth || "2.5"; // ✅ Thicker for kiosk
    const maxWidth = props?.maxWidth || "4.0"; // ✅ Thicker for kiosk
    const img_url = props?.url || null;
    
    const [imageURL, setImageURL] = useState(img_url);
    const sigCanvas = useRef({});
    const [open, setOpen] = useState(false);

    const closeModal = () => setOpen(false);
    const clear = () => sigCanvas.current.clear();

    const save = () => {
        const signatureData = sigCanvas.current.getTrimmedCanvas().toDataURL("image/png");
        setImageURL(signatureData);
        props?.setSignatureValue(signatureData);
        closeModal();
    };

    return (
        <Box 
            sx={{ 
                textAlign: "center", 
                bgcolor: "white", 
                p: 2, 
                borderRadius: 2, 
                boxShadow: 3, 
                maxWidth: "90vw", // ✅ Prevents overflow on wider screens
                mx: "auto" // ✅ Centers the box
            }}
        >
            {/* ✅ Large "Sign" Button */}
            <Button 
                variant="contained" 
                color="primary" 
                onClick={() => setOpen(true)}
                sx={{ fontSize: 24, py: 2, px: 4, borderRadius: 3, width: "100%" }}
            >
                ✍️ Sign
            </Button>

            {/* ✅ Display Signature if Available */}
            {imageURL || img_url ? (
                <Box sx={{ mt: 2, p: 1, border: "2px solid #1976d2", borderRadius: 2, bgcolor: "#f5f5f5" }}>
                    <SafeImage
                        src={imageURL || img_url}
                        fallbackSrc={SIGNATURE_PLACEHOLDER}
                        alt="Signature"
                        style={{ width: "100%", height: "auto", maxHeight: "200px" }}
                    />
                </Box>
            ) : null}

            {/* ✅ Fullscreen Popup for Signature */}
            <Popup open={open} onClose={closeModal} closeOnDocumentClick={false} modal>
                {close => (
                    <Box 
                        sx={{ 
                            p: 3, 
                            width: "95vw", // ✅ Reduced width to prevent overflow
                            height: "90vh", // ✅ Smaller than full height
                            maxWidth: "800px", // ✅ Prevents too large width
                            mx: "auto", // ✅ Centers it
                            overflow: "hidden", // ✅ Prevents overflow issues
                            bgcolor: "white",
                            borderRadius: 3,
                            boxShadow: 3
                        }}
                    >
                        
                        {/* Title */}
                        <Typography variant="h4" fontWeight="bold" textAlign="center" mb={2}>
                            ✍️ Please Sign Below
                        </Typography>

                        {/* ✅ Large Signature Pad */}
                        <Box sx={{ 
                            border: "2px solid black", 
                            borderRadius: 3, 
                            width: "100%", 
                            height: "50vh", // ✅ Slightly reduced to fit smaller screens
                            bgcolor: "#f5f5f5",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center"
                        }}>
                            <SignaturePad
                                ref={sigCanvas}
                                canvasProps={{ className: "signatureCanvas", style: { width: "100%", height: "100%" } }}
                                penColor={pencolor}
                                minWidth={minWidth}
                                maxWidth={maxWidth}
                            />
                        </Box>

                        {/* ✅ Buttons: Large & Easy to Click */}
                        <Grid container spacing={2} justifyContent="center" mt={3}>
                            <Grid item xs={12} md={4}>
                                <Button 
                                    variant="contained" 
                                    color="success" 
                                    fullWidth 
                                    onClick={save}
                                    sx={{ fontSize: 24, py: 2 }}
                                >
                                    ✅ Accept
                                </Button>
                            </Grid>
                            <Grid item xs={12} md={4}>
                                <Button 
                                    variant="contained" 
                                    color="warning" 
                                    fullWidth 
                                    onClick={clear}
                                    sx={{ fontSize: 24, py: 2 }}
                                >
                                    🔄 Clear
                                </Button>
                            </Grid>
                            <Grid item xs={12} md={4}>
                                <Button 
                                    variant="contained" 
                                    color="error" 
                                    fullWidth 
                                    onClick={close}
                                    sx={{ fontSize: 24, py: 2 }}
                                >
                                    ❌ Close
                                </Button>
                            </Grid>
                        </Grid>

                    </Box>
                )}
            </Popup>
        </Box>
    );
};

export default Signature;
